import { Badge } from "@mui/material";
import type { FC } from "react";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	name: string;
	online?: boolean;
};

export const ChatListRowAvatar: FC<Props> = ({ name, online }) => {
	return (
		<Badge
			overlap="circular"
			variant="dot"
			invisible={!online}
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			style={{ flexShrink: 0 }}
		>
			<InitialsAvatar name={name} size={48} />
		</Badge>
	);
};
